import { render, staticRenderFns } from "./CommissionTable.vue?vue&type=template&id=be6163ec&scoped=true"
import script from "./CommissionTable.vue?vue&type=script&lang=js"
export * from "./CommissionTable.vue?vue&type=script&lang=js"
import style0 from "./CommissionTable.vue?vue&type=style&index=0&id=be6163ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be6163ec",
  null
  
)

export default component.exports